import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { TABS } from '../../Interactions/constants';
import { InteractionBadges } from '../../hooks/useInteractionBadges';
import * as S from './styles';

type Tab = typeof TABS[number];

type MobileBottomBarProps = {
  activeTab: string;
  onTabClick: (tabId: string) => void;
  visibleTabs: Tab[];
  badges?: InteractionBadges;
};

const MobileBottomBar = ({
  activeTab,
  onTabClick,
  visibleTabs,
  badges,
}: MobileBottomBarProps) => {
  const { t } = useTranslation();

  const handleTabClick = useCallback(
    (tabId: string) => {
      onTabClick(tabId);
    },
    [onTabClick],
  );

  return (
    <S.BottomBarContainer>
      <S.TabsWrapper>
        {visibleTabs.map((tab) => {
          const badgeValue = badges?.[tab.id as keyof InteractionBadges];
          return (
            <S.TabButton
              key={tab.id}
              $active={activeTab === tab.id}
              onClick={() => handleTabClick(tab.id)}
            >
              <tab.icon size="1.25rem" />
              <S.TabLabel>{t(tab.title)}</S.TabLabel>
              {badgeValue && <S.Badge>{badgeValue}</S.Badge>}
            </S.TabButton>
          );
        })}
      </S.TabsWrapper>
    </S.BottomBarContainer>
  );
};

export default MobileBottomBar;
